import { render, staticRenderFns } from "./LongReadTargetTocLink.vue?vue&type=template&id=b90fca36&"
import script from "./LongReadTargetTocLink.vue?vue&type=script&lang=js&"
export * from "./LongReadTargetTocLink.vue?vue&type=script&lang=js&"
import style0 from "./LongReadTargetTocLink.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports